module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-56.f57b05e5.svg";